import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo";
import Navigation from "./Navigation"
import Footer from "./Footer"

const Layout = ({ location, children }) => {

  useEffect(
        () => {
            try {
                const UIkit = require("uikit/dist/js/uikit");
                const Icons = require("uikit/dist/js/uikit-icons");
                UIkit.use(Icons);
            } catch (e) {
                console.error("UIKit ERROR", e);
            }
        }, []
    )

  return (
    <>
        <Navigation />
        <main>
        {children}
        </main>
        {/* Humaine is read chapter to chapter: the end of the page is the end
            of a chapter, and a footer sitting in that seam would have to be
            scrolled past sixteen times. Playbooks are laid out the same way. */}
        {!["/contact-us/", "/humaine/"].includes(location?.pathname) &&
         !location?.pathname?.startsWith("/playbooks/") ?
        <Footer />
        :null}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
